export default __webpack_public_path__ + "static/media/compare-bulb.9bd720fe.svg";